import React, { useEffect, useState } from 'react'
import { Modal, Form, Input, Switch, Radio } from 'antd'

const { TextArea } = Input

const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
}
const DemandModal = ({ data,info, form, onOk, ...modalProps }) => {

  const { getFieldDecorator, getFieldValue, setFieldsValue } = form

  const [customerFamilies, setCustomerFamilies] = useState([])

  useEffect(() => {
    let families = [];
    (info.customerFamilies || []).map(_ => {
      if(_.name || _.telephone) {
        families = [...families, _]
      }
    })
    setCustomerFamilies([...families])
  }, [info])

  const handleOk = () => {
    const { validateFields, getFieldsValue } = form

    validateFields(errors => {
      if (errors) {
        return
      }
      const params = getFieldsValue()
      delete params.customerName
      delete params.people
      onOk({
        id: data.id || undefined,
        customerId: data.id ? undefined : data.customerId,
        ...params
      }, data.customerId)
    })
  }

  const handleFamiliesChange = (e) => {
    let val = e.target.value
    if(val) {
      if(customerFamilies[val - 1].name) {
        setFieldsValue({'familyName': customerFamilies[val-1].name})
      }
      if(customerFamilies[val - 1].telephone) {
        setFieldsValue({'familyPhone': customerFamilies[val-1].telephone})
      }
    }else {
      setFieldsValue({'familyName': '', 'familyPhone': ''})
    }
  }
  return (
    <Modal {...modalProps} onOk={() => handleOk()}>
      <Form layout="horizontal">
        <Form.Item label="客户" {...formItemLayout}>
          {getFieldDecorator('customerName', {
            initialValue: data.customerName,
          })(
            <Input autoComplete="off" disabled />
          )}
        </Form.Item>
        <Form.Item label="家属陪同" {...formItemLayout}>
          {getFieldDecorator('company', {
            initialValue: data.company,
            valuePropName: 'checked',
          })(
            <Switch checkedChildren="是" unCheckedChildren="否" />
          )}
        </Form.Item>
        {(getFieldValue('company') && customerFamilies.length > 0) && <Form.Item label="家属" {...formItemLayout}>
          {getFieldDecorator('people', {
          })(
            <Radio.Group onChange={e => handleFamiliesChange(e)}>
              {customerFamilies.map((_, index) => <Radio value={index + 1} key={index}>{_.relation}</Radio>)}
              <Radio value={null} >其他</Radio>
            </Radio.Group>
          )}
        </Form.Item>}
        {getFieldValue('company') && <Form.Item label="家属姓名" {...formItemLayout}>
          {getFieldDecorator('familyName', {
            initialValue: data.familyName,
            rules: [
              {
                required: true,
                message: '请输入家属姓名'
              },
            ],
          })(
            <Input type="text" disabled={getFieldValue('people') && getFieldValue('familyName')} />
          )}
        </Form.Item>}
        {getFieldValue('company') && <Form.Item label="家属电话" {...formItemLayout}>
          {getFieldDecorator('familyPhone', {
            initialValue: data.familyPhone,
            rules: [
              {
                required: true,
                message: '请输入家属电话'
              },
              {
                pattern: /^1[3-9]\d{9}$/,
                message: '格式错误'
              }
            ],
          })(
            <Input type="text" disabled={getFieldValue('people') && getFieldValue('familyPhone')} />
          )}
        </Form.Item>}
        <Form.Item label="主诉" {...formItemLayout}>
          {getFieldDecorator('complain', {
            initialValue: data.complain,
          })(
            <TextArea autoComplete="off" autoSize={{ maxRows: 8, minRows: 3 }} />
          )}
        </Form.Item>
        <Form.Item label="潜在异议" {...formItemLayout}>
          {getFieldDecorator('dissent', {
            initialValue: data.dissent,
          })(
            <TextArea autoComplete="off" autoSize={{ maxRows: 8, minRows: 3 }} />
          )}
        </Form.Item>
        <Form.Item label="备注" {...formItemLayout}>
          {getFieldDecorator('comment', {
            initialValue: data.comment,
          })(
            <TextArea autoComplete="off" autoSize={{ maxRows: 8, minRows: 3 }} />
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}
export default Form.create()(DemandModal)